const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Obtener familias de prendas con filtros y paginación
 */
export const getGarmentFamilies = async (filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 10 } = filters;

    const response = await fetch(`${API_URL}/garment-families/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query, page, limit }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener las familias de prendas');
    }

    const result = await response.json();

    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error al obtener familias de prendas:', error);
    throw error;
  }
};

/**
 * Crear nueva familia de prendas
 */
export const createGarmentFamily = async (familyData) => {
  try {
    const response = await fetch(`${API_URL}/garment-families/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(familyData),
    });

    if (!response.ok) {
      throw new Error('Error al crear la familia de prendas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al crear familia de prendas:', error);
    throw error;
  }
};

/**
 * Actualizar familia de prendas
 */
export const updateGarmentFamily = async (id, familyData) => {
  try {
    const response = await fetch(`${API_URL}/garment-families/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(familyData),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar la familia de prendas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al actualizar familia de prendas:', error);
    throw error;
  }
};

/**
 * Eliminar familia de prendas
 */
export const deleteGarmentFamily = async (id) => {
  try {
    const response = await fetch(`${API_URL}/garment-families/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar la familia de prendas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al eliminar familia de prendas:', error);
    throw error;
  }
};

/**
 * Exportar familias de prendas
 */
export const exportGarmentFamilies = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/garment-families/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query: filters }),
    });

    if (!response.ok) {
      throw new Error('Error al exportar las familias de prendas');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `familias_prendas_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    return { success: true };
  } catch (error) {
    console.error('Error al exportar familias de prendas:', error);
    throw error;
  }
};
